//Global CSS
import './css/app.scss';

//Enrutado
import { MsalProvider } from '@azure/msal-react';
import { Routes, Route, Navigate } from 'react-router-dom';

//Genericos
import Layout from './components/Layout';
import AccessDeniedPage from './pages/error/AccessDeniedPage';
import NotFoundPage from './pages/error/NotFoundPage';

//Pages
import Access from './pages/AccessEventPage';

const App = ({ pca }) => {
	return (
		<MsalProvider instance={pca}>
			<Routes>
				<Route path="/" element={<Navigate to="/eventos" />} />
				<Route path="/eventos" element={<Layout component={Access} />} />
				<Route
					path="/restringido"
					element={<Layout component={AccessDeniedPage} />}
				/>
				<Route path="*" element={<Layout component={NotFoundPage} />} />
			</Routes>
		</MsalProvider>
	);
};

export default App;
